import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./footer.css";
import logo from "../../Images/deepthi.png";
import svgimg from "../../Images/pattern.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <img src={svgimg} alt="" className="flipped-img" />

      <Container>
        <Row className="gy-4">
          {/* Logo */}
          <Col xs={12} md={2} className="text-center text-md-start mb-4">
            <img src={logo} alt="Logo" className="footer-logo mb-2" />
          </Col>

          {/* Accreditation */}
          <Col xs={12} md={3} className="text-center text-md-start mb-4">
            <h5 className="footer-heading">Accreditation</h5>
            <div className="accreditation mt-2">
              <p className="mb-1">Ministry of Education, Kerala State</p>
              <p className="mb-0">
                Ministry of Social Justice and Empowerment, Kerala
              </p>
            </div>
          </Col>

          {/* Quick Links */}
          <Col xs={12} md={3} className="text-center mb-4">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="list-unstyled footer-links">
              <li>
                <a href="/" className="quick-links">
                  Home
                </a>
              </li>
              <li>
                <a href="/about-us" className="quick-links">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" className="quick-links">
                  Services
                </a>
              </li>
              <li>
                <a href="/reach-us" className="quick-links">
                  Contact
                </a>
              </li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col xs={12} md={4} className="text-center text-md-end mb-4">
            <h5 className="footer-headings">Contact Us</h5>

            <div className="footer-text">
              <FaMapMarkerAlt className="footer-icon" />
              <span>
                Deepti Special School and Rehabilitation Centre, Manakala P.O,
                Adoor, 691551, Pathanamthitta District, Kerala.
              </span>
            </div>

            <div className="footer-text">
              <FaPhone className="footer-icon" />
              <span>+91 9633470888, 8714781966</span>
            </div>

            <div className="footer-text">
              <FaEnvelope className="footer-icon" />
              <span>mail.deepticentre@gmail.com</span>
            </div>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col className="text-center">
            <p className="mb-0 text-white">
              © {new Date().getFullYear()} Deepti Special School. All rights
              reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
